import { createContext, useContext } from "react";
import { LoginPayload, User } from "@/types";

export interface AuthState {
  userInfo: User | null;
  isLoggedIn: boolean;
  login(params: LoginPayload): void;
  logout(): void;
  githubLogin(code: String): void;
  updateUserInfo(params: Partial<User>): void;
}

export const authInitialState: AuthState = {
  isLoggedIn: false,
  userInfo: null,
  login: () => {},
  logout: () => {},
  githubLogin: () => {},
  updateUserInfo: () => {},
};

export const AuthContext = createContext<AuthState>(authInitialState);

export const useAuth = () => useContext(AuthContext);
